export default class Navbar {
  constructor() {
    this.initJqueryVariables();
    this.eventRegister();
    this.openMenuInProgress = false;
    localStorage.setItem('menuOpen', 'false');
  }

  initJqueryVariables() {
    this.$navbarAccountInfoDiv = $('.navbar-head-content__div');
    this.$navbar = $('.narbar-logged-in');
    this.$portalIndexSearch = $('#portal-index-search__input');
    this.$portalIndexSearchIcon = $('.search-icon');
    this.$portalIndexClearSearchIcon = $('.clear-search-icon');
  }

  eventRegister() {
    $('.navbar-head-icon__div').on('mouseenter', (e) => {
      this.$navbarAccountInfoDiv.show();
    })

    this.$navbarAccountInfoDiv.on('mouseleave', (e) => {
      this.$navbarAccountInfoDiv.hide();
    })

    this.$portalIndexSearch.on('focus', (e) => {
      this.$portalIndexSearchIcon.css('opacity', 1);
    })
    this.$portalIndexSearch.on('focusout', (e) => {
      this.$portalIndexSearchIcon.css('opacity', 0.5);
    })
    this.$portalIndexSearch.on('input', (e) => {
      this.$portalIndexClearSearchIcon.css('display', 'block');
    })
    this.$portalIndexClearSearchIcon.on('click', (e) => {
      this.$portalIndexSearch.val('');
      this.$portalIndexClearSearchIcon.css('display', 'none');
    })

    $('.navbar-toggler.collapsed .navbar-toggler-icon').on('click', (e) => {
      if (this.openMenuInProgress == true) {
        return;
      } else {
        this.openMenuInProgress = true;
        const menuOpenStatus = localStorage.getItem('menuOpen');
        if (menuOpenStatus == 'false') {
          localStorage.setItem('menuOpen', 'true');
          //this.$navbar.next().css('filter', 'blur(8px)');
          $('.blur-background').show();
          $('.narbar-logged-in').css('position', 'unset');
        }
        if (menuOpenStatus == 'true') {
          localStorage.setItem('menuOpen', 'false');
          //this.$navbar.next().css('filter', 'none');
          $('.blur-background').hide();
          $('.narbar-logged-in').css('position', 'fixed');
        }
        this.openMenuInProgress = false;
      }
    })
  }
}
